export default __webpack_public_path__ + "static/media/No888Closed.c2a064f0.jpg";